import {
  getTrackingStatusChipColors,
  getTrackingStatusLabel,
} from "@lhd/features/TrackingTime/until";
import { CurrentTimeInfo, WorkerLogtimeData } from "@lhd/types";
import "dayjs/locale/ja";
import { Styles } from "./styled";
import dayjs from "dayjs";
import "dayjs/locale/ja";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import Status from "../../components/Status";
import { DATE_TIME_FORMAT } from "@lhd/constants";

dayjs.extend(utc);
dayjs.extend(timezone);

const WORK_LOG_TIMEZONE = "Asia/Tokyo";

interface IProps {
  isMobileOrTablet?: boolean;
  className?: string;
  workerLogtimesData?: WorkerLogtimeData;
  currentTimeData?: CurrentTimeInfo;
  datetimeWithTimeRes?: Date;
}

const StatusTracking = (props: IProps) => {
  const {
    isMobileOrTablet,
    className,
    workerLogtimesData,
    currentTimeData,
    datetimeWithTimeRes,
  } = props;
  dayjs.locale("ja");
  const statusLabel = getTrackingStatusLabel(
    workerLogtimesData?.logtime_status,
  );
  const chipColors = getTrackingStatusChipColors(statusLabel);

  const displayDatetime =
    datetimeWithTimeRes ?? currentTimeData?.current_datetime;

  return (
    <Styles className={className || ""} isMobileOrTablet={isMobileOrTablet}>
      {isMobileOrTablet ? (
        <>
          <Status label={statusLabel} chipColors={chipColors} />
          {displayDatetime
            ? dayjs(displayDatetime)
                .tz(WORK_LOG_TIMEZONE)
                .format(DATE_TIME_FORMAT.DATE_JP_WITH_DAY)
            : null}
        </>
      ) : (
        statusLabel
      )}
    </Styles>
  );
};

export default StatusTracking;
